/* LH | Poster frame upsell by rule (Leon 21.10.2026), product page part. Block and rules: snippets/lh-frame-upsell.liquid.
 *
 * - Shows the frame price for the poster size that is selected right now, and the colour picker while the
 *   switch is on (switch ON by default, black first).
 * - After the poster of THIS page was added (TeeInBlue's /cart/add), and only when the switch is on:
 *     1. give the poster line _tib_addon_variant = <frame variant id>:1
 *     2. add the frame variant of the same size and the chosen colour, quantity = poster quantity,
 *        property _tib_customization_id = _customization_id of the poster, exactly as the TeeInBlue frame layer,
 *        unless TeeInBlue already added it
 *   These are exactly the properties the TeeInBlue frame layer set until now, so the poster goes as one framed
 *   item to MerchOne and fulfillment needs no change. Never _partner_of (nightly run: partner set key chain).
 *   The order matters: TeeInBlue's own cart check (autofixer) compares lines with _tib_customization_id against
 *   the _tib_addon_variant of their parent. A frame without a flagged poster is removed by it, a flagged poster
 *   without a frame gets the frame added by it. Flag first, so the check never sees a frame without a parent.
 * - The old TeeInBlue frame field (class ck-upsell-frame) stays hidden. In some size templates it is required,
 *   so it is kept on its "none" option (tile ck-none-tile from teeinblue-custom.js), otherwise TeeInBlue
 *   blocks the add to cart on a field the customer cannot see.
 * - Cart rules afterwards (frame follows the poster quantity, removed with it, poster cleaned when the frame
 *   is gone): assets/lh-partner-upsell-cart.js.
 */
(function () {
  if (window.__lhFrameLoaded) return;
  window.__lhFrameLoaded = true;

  var root = document.getElementById('lh-frame-upsell');
  var dataEl = document.getElementById('lh-frame-data');
  if (!root || !dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { console.warn('[LH Frame] bad data', e); return; }
  var frames = (data.frames || []).filter(Boolean);
  var posterHandle = root.getAttribute('data-poster-handle');
  var toggle = document.getElementById('lh-frame-toggle');
  var box = document.getElementById('lh-frame-box');
  var priceEl = document.getElementById('lh-frame-price');
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pending = window.__lhFramePending = window.__lhFramePending || {};

  // Poster sizes from SKU ("30x20") and frame sizes from the option ("30x20") use the same key.
  // TeeInBlue switches the size by URL (?variant=) and leaves the form's id input on the first variant
  // until it submits, so the URL wins.
  function selectedPosterVariantId() {
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl && (data.posters || {})[fromUrl]) return fromUrl;
    var input = document.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input ? String(input.value) : '';
  }
  function sizeOf(variantId) { return String((data.posters || {})[variantId] || '').toLowerCase(); }
  function color() {
    var c = root.querySelector('input[name="lh-frame-color"]:checked');
    return c ? c.value : '';
  }
  function frameFor(size, col) {
    return frames.find(function (f) { return f.size === size && f.color === col; }) || null;
  }
  function currentFrame() { return frameFor(sizeOf(selectedPosterVariantId()), color()); }

  function render() {
    var f = currentFrame(), size = sizeOf(selectedPosterVariantId());
    // Tile "no frame" has an empty value: the hidden toggle mirrors whether a frame is chosen
    toggle.checked = !!color();
    priceEl.textContent = f ? '(+' + f.price + ')' : '';
    root.querySelectorAll('[data-lh-frame-price]').forEach(function (el) {
      var t = frameFor(size, el.getAttribute('data-lh-frame-price'));
      el.textContent = t ? '+' + t.price : '';
      el.closest('label').style.display = t ? '' : 'none';
    });
    // No frame for this size or colour (sold out in this market): switch off and hide
    root.style.display = frames.some(function (x) { return x.size === sizeOf(selectedPosterVariantId()); }) ? '' : 'none';
  }
  function renderSoon() { setTimeout(render, 50); setTimeout(render, 600); }

  // Old TeeInBlue frame field: keep it on "none". TeeInBlue reacts to a click on the label, not to input.checked.
  // "None" = the tile teeinblue-custom.js did not map to an add-on variant (ck-none-tile, or no ck-addon-tile while
  // the others have one; seen on FR 22.10.2026), so it works in every language.
  function isNoneTile(tile, field) {
    if (!tile) return false;
    if (tile.classList.contains('ck-none-tile')) return true;
    return !tile.classList.contains('ck-addon-tile') && !!field.querySelector('.ck-addon-tile');
  }
  function clearOldField() {
    document.querySelectorAll('#teeFormInputs .ck-upsell-frame').forEach(function (field) {
      var checked = field.querySelector('input:checked');
      if (checked && isNoneTile(checked.closest('.tee-clipart'), field)) return;
      var none = Array.prototype.find.call(field.querySelectorAll('.tee-clipart'), function (t) { return isNoneTile(t, field); });
      var label = none && none.querySelector('label');
      if (label) label.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    });
  }

  // Into the TeeInBlue form, below the personalisation, like the T-shirt block
  function moveIntoForm() {
    var form = document.querySelector('#teeFormInputs');
    if (!form) return false;
    if (root.parentElement !== form) form.appendChild(root);
    return true;
  }
  // TeeInBlue rebuilds the form when the size changes: move the block back and reset the old field each time
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; moveIntoForm(); clearOldField(); render(); }, 100);
  }).observe(document.body, { childList: true, subtree: true });
  moveIntoForm();
  clearOldField();

  toggle.addEventListener('change', render);
  root.addEventListener('change', render);
  document.addEventListener('change', renderSoon);
  window.addEventListener('popstate', renderSoon);
  // The theme also changes the id input without a change event on it
  var idInput = document.querySelector('product-form form input[name="id"]');
  if (idInput && window.MutationObserver) new MutationObserver(render).observe(idInput, { attributes: true, attributeFilter: ['value'] });
  render();

  /* ---------- cart: flag the poster, then add the frame ---------- */
  var handled = {};   // customization ids that were in the cart before or already got a frame
  var busy = false, again = '';
  var own = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-LH-Cart': '1' };

  function prop(i, k) { return i.properties ? i.properties[k] : undefined; }
  function getCart() { return fetch(cartRoot + 'cart.js', { headers: own }).then(function (r) { return r.json(); }); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  getCart().then(function (cart) {
    (cart.items || []).forEach(function (i) { var c = prop(i, '_customization_id'); if (c) handled[String(c)] = true; });
  }).catch(function () {});

  async function afterAdd(chosen) {
    if (busy) { again = chosen; return; }
    busy = true;
    var cid = '';
    try {
      var items = (await getCart()).items || [];
      var framed = {};
      items.forEach(function (i) { var c = prop(i, '_tib_customization_id'); if (c) framed[String(c)] = true; });
      var poster = items.find(function (i) {
        var c = prop(i, '_customization_id');
        return i.handle === posterHandle && c && !handled[String(c)] && !framed[String(c)];
      });
      if (!poster) return;
      cid = String(prop(poster, '_customization_id'));
      handled[cid] = true;
      var f = frameFor(String(poster.sku || '').toLowerCase().split('-').pop(), chosen);
      if (!f) { console.warn('[LH Frame] no frame for', poster.sku, chosen); return; }
      pending[cid] = true;

      // 1. flag the poster
      var props = Object.assign({}, poster.properties || {}, { _tib_addon_variant: f.id + ':1' });
      var ch = await fetch(cartRoot + 'cart/change.js', {
        method: 'POST', headers: own,
        body: JSON.stringify({ id: poster.key, quantity: poster.quantity, properties: props })
      });
      if (!ch.ok) { console.warn('[LH Frame] flag failed', ch.status); return; }

      // 2. add the frame, unless TeeInBlue's cart check added it already (it did after about 0.6 s in the test)
      await wait(1500);
      var has = ((await getCart()).items || []).some(function (i) {
        return Number(i.variant_id) === Number(f.id) && String(prop(i, '_tib_customization_id') || '') === cid;
      });
      if (!has) {
        var add = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST', headers: own,
          body: JSON.stringify({ items: [{ id: f.id, quantity: poster.quantity, properties: { _tib_customization_id: cid } }] })
        });
        if (!add.ok) console.warn('[LH Frame] add failed', add.status);
      }

      // Same drawer refresh as the T-shirt upsell (assets/cart.js)
      var html = new DOMParser().parseFromString(await (await fetch(cartRoot + 'cart?section_id=cart-drawer', { headers: own })).text(), 'text/html');
      ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
        var target = document.querySelector(sel), source = html.querySelector(sel);
        if (target && source) target.replaceWith(source);
      });
    } catch (e) {
      console.warn('[LH Frame] add frame failed', e);
    } finally {
      if (cid) delete pending[cid];
      busy = false;
      if (again) { var c = again; again = ''; afterAdd(c); }
    }
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = (init && init.headers) || {};
    var mine = (typeof h.get === 'function' ? h.get('X-LH-Cart') : h['X-LH-Cart']) === '1';
    // Read the choice at click time, before anything re-renders
    var chosen = toggle.checked ? color() : '';
    var p = origFetch.apply(this, arguments);
    if (!mine && chosen && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok) afterAdd(chosen); }).catch(function () {});
    }
    return p;
  };
})();
